import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var EmptyListSvg = function EmptyListSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#empty-list__a)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#CCD4FF",
        d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#A5AEFF",
        d: "M7.2 19a.4.4 0 0 1-.401-.4v-12a.4.4 0 0 1 .4-.4h5.6a.55.55 0 0 1 .34.14l2.72 2.72c.077.077.14.23.14.34v9.2a.4.4 0 0 1-.401.4z",
        opacity: 0.35
      }), /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M8.4 17.8a.4.4 0 0 1-.402-.4v-12a.4.4 0 0 1 .4-.4h5.6a.55.55 0 0 1 .34.14l2.72 2.72c.077.077.14.23.14.34v9.2a.4.4 0 0 1-.401.4z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#A5AEFF",
        d: "M16.998 8.2h-3v-3z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#171717",
        d: "M16.797 17.8a.4.4 0 0 0 .401-.4V8.2a.55.55 0 0 0-.14-.34l-2.72-2.72a.55.55 0 0 0-.34-.14h-5.6c-.221 0-.4.181-.4.4v12c0 .22.18.4.401.4zm-.198-.4H8.597a.2.2 0 0 1-.199-.198V5.598c0-.11.09-.198.199-.198h5.212l-.01 2.602c0 .22.178.398.397.398h2.602v8.8a.2.2 0 0 1-.2.2m-2.2-9.4c-.11 0-.201-.09-.201-.2v-2c0-.109.063-.137.141-.059l2.118 2.118c.077.077.051.141-.06.141z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#767676",
        d: "M9.9 13.8a.3.3 0 1 1 0 .6.3.3 0 0 1 0-.6m5.6.2a.1.1 0 0 1 .1.1l-.002.018a.1.1 0 0 1-.099.082h-4.6a.1.1 0 1 1 0-.2zm-5.6-1.8a.3.3 0 1 1 0 .6.3.3 0 0 1 0-.6m5.6.2a.1.1 0 0 1 .1.1l-.002.018a.1.1 0 0 1-.099.082h-4.6a.1.1 0 1 1 0-.2zm-5.6-1.8a.3.3 0 1 1 0 .6.3.3 0 0 1 0-.6m5.6.2a.1.1 0 0 1 .1.1l-.002.018a.1.1 0 0 1-.099.082h-4.6a.1.1 0 1 1 0-.2z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "empty-list__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      })
    })]
  });
};
export var EmptyList = function EmptyList(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: EmptyListSvg
  }));
};